import buildRoutes from 'ember-engines/routes';
export default buildRoutes(function () {});